import React from "react";

import clsx from "clsx";

import { useUser } from "@components/user-context";
import { type Documents } from "@north-beam/nb-client-side";

import { DocumentsTableRow } from "./documents-table-row";

type Doc = Documents["me"]["documents"]["data"][number];
type ContentTypes = Record<string, string>;

export interface DocumentsRawTableProps {
  readonly data: Doc[];
  readonly contentTypes: ContentTypes;
  readonly onDeleteSuccess: () => void;
  className?: string;
}

export const DocumentsRawTable = ({
  contentTypes,
  data,
  onDeleteSuccess,
  ...props
}: DocumentsRawTableProps) => {
  const { user } = useUser();
  return (
    <table
      {...props}
      className={clsx("table table-bordered bg-white mb-0", props.className)}
    >
      <thead className="thead-light">
        <tr>
          <th scope="col" className="th-sm">
            Document
          </th>
          <th scope="col" className="th-sm">
            Updated At
          </th>
          <th scope="col" className="th-sm">
            Created At
          </th>
          <th scope="col" className="th-sm">
            Content
          </th>
          <th scope="col" className="th-sm text-center">
            <div>Actions</div>
          </th>
        </tr>
      </thead>
      <tbody>
        {data.length > 0 ? (
          data.map((document) => (
            <DocumentsTableRow
              key={document.id}
              document={document}
              onDeleteSuccess={onDeleteSuccess}
            >
              {contentTypes[document.metadata.contentType] ||
                document.metadata.contentType}
            </DocumentsTableRow>
          ))
        ) : (
          <tr>
            <td colSpan={user.isAdmin ? 5 : 4}>
              No documents have been currently uploaded.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
